import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';

@Component({
  selector: 'rt-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-icon]': 'iconName',
    '[class.no-underline]': 'noUnderline',
  },
})
export class LinkComponent {
  @Input() public iconName: IconName;
  @Input() public url: string;
  @Input() public target: string = '_blank';
  @Input() public label: string;
  @Input() public noUnderline: boolean = false;
}
